import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../lib/authApi";
import { useAuth } from "../auth/AuthProvider";

export default function RegisterAccount() {
    const nav = useNavigate();
    const { refresh } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        try {
            await register(email, password);
            await refresh();
            nav("/manager");
        } catch (e) {
            setErr(e.message);
        }
    }

    return (
        <div className="card">
            <h1>Account erstellen</h1>
            {err && <div className="alert alert--error">{err}</div>}

            <form onSubmit={onSubmit} className="form">
                <label className="form-label">E-Mail</label>
                <input className="input" value={email} onChange={(e)=>setEmail(e.target.value)} />

                <label className="form-label">Passwort (min. 8)</label>
                <input className="input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} />

                <button className="btn" type="submit">Registrieren</button>
            </form>

            <div style={{ marginTop: 10 }}>
                Schon ein Konto? <Link to="/login">Login</Link>
            </div>
        </div>
    );
}